export const WEBINAR_INDEX = {
  en: {
    seo: {
      title: 'What’s happening at Screver?',
      description:
        'Check out our events schedule for the coming months – virtual, hybrid, and in-person.',
      image: '',
    },
    hero: {
      title: 'What’s happening at Screver?',
      subtitle:
        'Check out our events schedule for the coming months – virtual, hybrid, and in-person.',
    },
    onDemandTitle: 'On-demand webinars and events',
    langSwitcher: 'Event language',
  },
  de: {
    seo: {
      title: 'Was ist bei Screver los?',
      description:
        'Sehen Sie sich unseren Veranstaltungskalender für die kommenden Monate an - virtuell, hybrid und persönlich.',
      image: '',
    },
    hero: {
      title: 'Was ist bei Screver los?',
      subtitle:
        'Sehen Sie sich unseren Veranstaltungskalender für die kommenden Monate an - virtuell, hybrid und persönlich.',
    },
    onDemandTitle: 'Webinare und Veranstaltungen auf Abruf',
    langSwitcher: 'Sprache der Veranstaltung',
  },
};
